import { convertNumbers } from "../../utils/ConvertNumbers";
import PersonIcon from "@material-ui/icons/Person";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import TodayIcon from "@material-ui/icons/Today";
import Speed from "@material-ui/icons/Speed";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";
import { Grid, Typography } from "@material-ui/core";
import CardMedia from "@material-ui/core/CardMedia";
import ProjectImg from "../../assets/img/project.jpg";
import ProjectImg2 from "../../assets/img/project2.jpg";
import CardContent from "@material-ui/core/CardContent";
import { Card } from "@material-ui/core";
import { useHistory } from "react-router";
import moment from "jalali-moment";

const Project = (props) => {
  const image = props.index % 2 === 0 ? ProjectImg : ProjectImg2;
  const history = useHistory();

  const goToDetails = () => {
    const link = "/admin/project-dash/" + props.data.id;
    history.push(link);
  };

  return (
    <>
      <Grid
        style={{ paddingRight: "8px", paddingLeft: "8px" }}
        item
        sx={12}
        sm={6}
        md={4}
        lg={3}
      >
        <Card style={{ marginBottom: "8px" }}>
          <CardMedia
            component="img"
            height="140"
            image={image}
            alt="project-media"
          />
          <CardContent>
            <Typography align="center" style={{ fontWeight: "bold" }}>
              {convertNumbers(props.data.name)}
            </Typography>
            <div
              style={{
                height: "16px",
                borderBottom: "1px solid #e6e9ed",
                marginBottom: "16px",
              }}
            ></div>
            {/* <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <PersonIcon />
              </Grid>
              <Grid item>{props.data.user}</Grid>
            </Grid> */}
            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <LocationOnIcon />
              </Grid>
              <Grid item>{props.data.location}</Grid>
            </Grid>
            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <TodayIcon />
              </Grid>
              <Grid item>
                <span>شروع از </span>
                {convertNumbers(
                  moment(props.data.date).locale("fa").format("YYYY/MM/DD")
                )}
              </Grid>
            </Grid>
            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <Speed />
              </Grid>
              <Grid item>
                <span>{convertNumbers(props.data.counters)}</span>
                <span> کنتور فعال</span>
              </Grid>
            </Grid>

            <Grid
              style={{
                fontSize: "14px",
                color: "#73879c",
                paddingTop: "16px",
              }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid item sx={12} sm={12} md={12} lg={12}>
                <Button
                  onClick={goToDetails}
                  style={{
                    width: "100%",
                    color: "#1976d2",
                  }}
                  variant="outlined"
                  endIcon={<InfoIcon />}
                >
                  جزئیات بیشتر
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default Project;
